import isNaN from 'lodash/isNaN'
import isNil from 'lodash/isNil'

import type React from 'react'

export const customOnChange = (
  evt: React.ChangeEvent<HTMLInputElement>,
  max: number,
  min: number,
  allowEmpty: boolean,
  onChange: (newValue: number) => void
) => {
  const parsedValue = Number.parseFloat(evt.currentTarget.value)
  const isValueCorrect: boolean =
    !Number.isNaN(parsedValue) &&
    (isNil(min) || parsedValue >= min) &&
    (isNil(max) || parsedValue <= max)

  if (isValueCorrect) {
    onChange(parsedValue)
  } else {
    onChange((allowEmpty ? null : Number(min)) ?? 0)
  }
}

export const isNilOrNan = <T>(value: T) => isNil(value) || isNaN(value)
